'use client'

import { useEffect, useId, useRef, useState } from 'react'
import clsx from 'clsx'

const shapes = [
  {
    width: 655,
    height: 680,
    path: 'M537.827 9.245A11.5 11.5 0 0 1 549.104 0h63.366c7.257 0 12.7 6.64 11.277 13.755l-25.6 128A11.5 11.5 0 0 1 586.87 151h-28.275a15.999 15.999 0 0 0-15.689 12.862l-59.4 297c-1.98 9.901 5.592 19.138 15.689 19.138h17.275l.127.001c.85.009 1.701.074 2.549.009 11.329-.874 21.411-7.529 24.88-25.981.002-.012.016-.016.023-.007.008.009.022.005.024-.006l24.754-123.771A11.5 11.5 0 0 1 580.104 321h63.366c7.257 0 12.7 6.639 11.277 13.755l-25.6 128A11.5 11.5 0 0 1 617.87 472H559c-22.866 0-28.984 7.98-31.989 25.931-.004.026-.037.035-.052.014-.015-.02-.048-.013-.053.012l-24.759 123.798A11.5 11.5 0 0 1 490.87 631h-29.132a14.953 14.953 0 0 0-14.664 12.021c-4.3 21.502-23.18 36.979-45.107 36.979H83.502c-29.028 0-50.8-26.557-45.107-55.021l102.4-512C145.096 91.477 163.975 76 185.902 76h318.465c10.136 0 21.179-5.35 23.167-15.288l10.293-51.467Zm-512 160A11.5 11.5 0 0 1 37.104 160h63.366c7.257 0 12.7 6.639 11.277 13.755l-25.6 128A11.5 11.5 0 0 1 74.87 311H11.504c-7.257 0-12.7-6.639-11.277-13.755l25.6-128Z',
  },
  {
    width: 719,
    height: 680,
    path: 'M89.827 9.245A11.5 11.5 0 0 1 101.104 0h63.366c7.257 0 12.7 6.64 11.277 13.755l-25.6 128A11.5 11.5 0 0 1 138.87 151H75.504c-7.257 0-12.7-6.639-11.277-13.755l25.6-128Zm-64 321A11.5 11.5 0 0 1 37.104 321h63.366c7.257 0 12.7 6.639 11.277 13.755l-25.6 128A11.5 11.5 0 0 1 74.87 472H11.504c-7.257 0-12.7-6.639-11.277-13.755l25.6-128ZM526.795 470a15.999 15.999 0 0 0-15.689 12.862l-32.032 160.159c-4.3 21.502-23.18 36.979-45.107 36.979H115.502c-29.028 0-50.8-26.557-45.107-55.021l102.4-512C177.096 91.477 195.975 76 217.902 76h318.465c29.028 0 50.8 26.557 45.107 55.021l-33.768 168.841c-1.98 9.901 5.592 19.138 15.689 19.138h17.075l.127.001c.85.009 1.701.074 2.549.009 11.329-.874 21.411-7.529 24.88-25.981.002-.012.016-.016.023-.007.008.009.022.005.024-.006l24.754-123.771A11.5 11.5 0 0 1 644.104 160h63.366c7.257 0 12.7 6.639 11.277 13.755l-25.6 128A11.5 11.5 0 0 1 681.87 311H623c-22.866 0-28.984 7.98-31.989 25.931-.004.026-.037.035-.052.014-.015-.02-.048-.013-.053.012l-24.759 123.798A11.5 11.5 0 0 1 554.87 470h-28.075Z',
  },
  {
    width: 719,
    height: 680,
    path: 'M632.827 9.245A11.5 11.5 0 0 1 644.104 0h63.366c7.257 0 12.7 6.64 11.277 13.755l-25.6 128A11.5 11.5 0 0 1 681.87 151h-28.275a15.999 15.999 0 0 0-15.689 12.862l-95.832 479.159c-4.3 21.502-23.18 36.979-45.107 36.979H178.502c-29.028 0-50.8-26.557-45.107-55.021l102.4-512C240.096 91.477 258.975 76 280.902 76h318.465c10.136 0 21.179-5.35 23.167-15.288l10.293-51.467Zm0 479A11.5 11.5 0 0 1 644.104 479h63.366c7.257 0 12.7 6.639 11.277 13.755l-25.6 128A11.5 11.5 0 0 1 681.87 630h-63.366c-7.257 0-12.7-6.639-11.277-13.755l25.6-128ZM37.104 159a11.5 11.5 0 0 0-11.277 9.245l-25.6 128C-1.196 303.361 4.247 310 11.504 310H74.87a11.5 11.5 0 0 0 11.277-9.245l24.76-123.798a.03.03 0 0 1 .052-.012c.015.021.048.012.052-.014C114.016 158.98 120.134 151 143 151h58.87a11.5 11.5 0 0 0 11.277-9.245l25.6-128C240.17 6.64 234.727 0 227.47 0h-63.366a11.5 11.5 0 0 0-11.277 9.245l-24.754 123.771c-.002.011-.016.015-.024.006-.007-.009-.021-.005-.023.007-3.469 18.452-13.551 25.107-24.88 25.981-.848.065-1.699 0-2.549-.009l-.127-.001H37.104Z',
  },
]

interface StylizedVideoProps {
  src: string
  shape?: 0 | 1 | 2
  className?: string
  autoPlay?: boolean
  loop?: boolean
  muted?: boolean
  playsInline?: boolean
  controls?: boolean
  poster?: string
  preload?: 'none' | 'metadata' | 'auto'
  captionsSrc?: string
  captionsLabel?: string
  captionsSrcLang?: string
  lazyLoad?: boolean
  decorative?: boolean
}

export function StylizedVideo({
  src,
  shape = 0,
  className,
  autoPlay = true,
  loop = true,
  muted = true,
  playsInline = true,
  controls = false,
  poster,
  preload = 'metadata',
  captionsSrc,
  captionsLabel = 'Deutsch',
  captionsSrcLang = 'de',
  lazyLoad = true,
  decorative = true,
}: StylizedVideoProps) {
  let id = useId()
  let { width, height, path } = shapes[shape]
  let scrollRef = useRef<HTMLDivElement>(null)
  let [isInView, setIsInView] = useState(false)

  useEffect(() => {
    const el = scrollRef.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true)
          observer.disconnect()
        }
      },
      { rootMargin: '200px 0px' },
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const [isSafariIOS, setIsSafariIOS] = useState(false)

  useEffect(() => {
    // Detect Safari on iOS - these have issues with SVG foreignObject + video clipping
    const ua = navigator.userAgent
    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua)
    setIsSafariIOS(isIOS || isSafari)
  }, [])

  // Create CSS mask data URI for iOS
  const maskDataUri = `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">
      <path d="${path}" fillRule="evenodd" clipRule="evenodd" fill="white"/>
    </svg>`,
  )}`
  const shouldRenderVideo = isInView || !lazyLoad

  const videoProps = {
    src,
    autoPlay: shouldRenderVideo && autoPlay,
    loop,
    muted,
    playsInline,
    controls,
    poster,
    preload: shouldRenderVideo ? preload : 'none',
    className: 'h-full w-full bg-zinc-100 object-cover',
    'aria-hidden': decorative,
  } as const

  return (
    <div
      ref={scrollRef}
      className={clsx(className, 'relative flex aspect-719/680 w-full')}
      style={{
        filter: isInView ? 'grayscale(0)' : 'grayscale(1)',
        transition: 'filter 1.2s ease-out',
      }}
    >
      {isSafariIOS ? (
        // CSS mask fallback for iOS Safari
        <div className="group relative h-full w-full">
          <div
            className="origin-center scale-100 transition duration-500 motion-safe:group-hover:scale-105"
            style={{
              width: '100%',
              height: '100%',
              maskImage: `url("${maskDataUri}")`,
              WebkitMaskImage: `url("${maskDataUri}")`,
              maskSize: '100% 100%',
              WebkitMaskSize: '100% 100%',
              maskRepeat: 'no-repeat',
              WebkitMaskRepeat: 'no-repeat',
              maskPosition: 'center',
              WebkitMaskPosition: 'center',
              // Force compositing layer for better rendering
              transform: 'translateZ(0)',
              WebkitTransform: 'translateZ(0)',
            }}
          >
            {shouldRenderVideo ? (
              <video
                {...videoProps}
                style={{
                  aspectRatio: `${width} / ${height}`,
                  minWidth: '100%',
                  minHeight: '100%',
                }}
              >
                {captionsSrc && (
                  <track
                    kind="captions"
                    src={captionsSrc}
                    srcLang={captionsSrcLang}
                    label={captionsLabel}
                    default
                  />
                )}
              </video>
            ) : (
              <div
                aria-hidden="true"
                className="h-full w-full bg-zinc-100"
                style={{
                  aspectRatio: `${width} / ${height}`,
                  minWidth: '100%',
                  minHeight: '100%',
                }}
              />
            )}
          </div>
          {/* Stroke outline using SVG overlay */}
          <svg
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
            className="pointer-events-none absolute inset-0 h-full w-full"
          >
            <path
              d={path}
              strokeWidth="2"
              className="stroke-zinc-950/10"
              fillRule="evenodd"
              clipRule="evenodd"
            />
          </svg>
        </div>
      ) : (
        // SVG clipPath version for desktop browsers
        <svg viewBox={`0 0 ${width} ${height}`} fill="none" className="h-full">
          <g clipPath={`url(#${id}-clip)`} className="group">
            <g className="origin-center scale-100 transition duration-500 motion-safe:group-hover:scale-105">
              <foreignObject width={width} height={height}>
                {shouldRenderVideo ? (
                  <video
                    {...videoProps}
                    style={{
                      aspectRatio: `${width} / ${height}`,
                    }}
                  >
                    {captionsSrc && (
                      <track
                        kind="captions"
                        src={captionsSrc}
                        srcLang={captionsSrcLang}
                        label={captionsLabel}
                        default
                      />
                    )}
                  </video>
                ) : (
                  <div
                    aria-hidden="true"
                    className="h-full w-full bg-zinc-100"
                    style={{
                      aspectRatio: `${width} / ${height}`,
                    }}
                  />
                )}
              </foreignObject>
            </g>
            <use
              href={`#${id}-shape`}
              strokeWidth="2"
              className="stroke-zinc-950/10"
            />
          </g>
          <defs>
            <clipPath id={`${id}-clip`}>
              <path
                id={`${id}-shape`}
                d={path}
                fillRule="evenodd"
                clipRule="evenodd"
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </div>
  )
}
